import { queryOptions, useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { Address, zeroAddress } from 'viem';

import { teamLeaderboardQuery } from './teamLeaderboardQuery';

export const useTeamLeaderboardQuery = (epoch?: number, size?: number) => {
  const [page, setPage] = useState(1);
  const reactQueryOptions = useMemo(() => {
    const param = {
      epoch,
      page: page - 1,
      size: size ?? 10,
    };
    
return queryOptions({
      queryKey: teamLeaderboardQuery.getKey(param),
      queryFn: teamLeaderboardQuery.getFn(param),
      enabled: !!epoch,
    });
  }, [epoch, page]);

  const query = useQuery(reactQueryOptions);

  return {
    query,
    setPage,
  };
};
